/* tslint:disable */
/* eslint-disable */
/**
 * ElisTech API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.0
 * Contact: info@ideatech.cz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiV1AccountLoginPost200Response } from '../models';
// @ts-ignore
import type { ApiV1AccountLoginPostRequest } from '../models';
// @ts-ignore
import type { ApiV1AccountPasswordPutRequest } from '../models';
// @ts-ignore
import type { ApiV1AccountRegisterPost200Response } from '../models';
// @ts-ignore
import type { ApiV1AccountWebLogoutPost200Response } from '../models';
// @ts-ignore
import type { ApiV1AccountWebRefreshPost200Response } from '../models';
// @ts-ignore
import type { Message } from '../models';
// @ts-ignore
import type { RegisterRequest } from '../models';
// @ts-ignore
import type { ResendActivationRequest } from '../models';
/**
 * AuthApi - axios parameter creator
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary User login
         * @param {ApiV1AccountLoginPostRequest} [apiV1AccountLoginPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccountLoginPost: async (apiV1AccountLoginPostRequest?: ApiV1AccountLoginPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/account/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiV1AccountLoginPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Forgot password request
         * @param {ApiV1AccountPasswordPutRequest} [apiV1AccountPasswordPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccountPasswordPut: async (apiV1AccountPasswordPutRequest?: ApiV1AccountPasswordPutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/account/password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiV1AccountPasswordPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary User registration
         * @param {RegisterRequest} registerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccountRegisterPost: async (registerRequest: RegisterRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registerRequest' is not null or undefined
            assertParamExists('apiV1AccountRegisterPost', 'registerRequest', registerRequest)
            const localVarPath = `/api/v1/account/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resend activation email
         * @param {ResendActivationRequest} resendActivationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccountResendActivationPost: async (resendActivationRequest: ResendActivationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resendActivationRequest' is not null or undefined
            assertParamExists('apiV1AccountResendActivationPost', 'resendActivationRequest', resendActivationRequest)
            const localVarPath = `/api/v1/account/resend-activation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resendActivationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Web user login (sets refresh cookie)
         * @param {ApiV1AccountLoginPostRequest} [apiV1AccountLoginPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccountWebLoginPost: async (apiV1AccountLoginPostRequest?: ApiV1AccountLoginPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/account/web/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiV1AccountLoginPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Logout and clear refresh cookie
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccountWebLogoutPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/account/web/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Rotate web refresh token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccountWebRefreshPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/account/web/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthApi - functional programming interface
 */
export const AuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary User login
         * @param {ApiV1AccountLoginPostRequest} [apiV1AccountLoginPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AccountLoginPost(apiV1AccountLoginPostRequest?: ApiV1AccountLoginPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1AccountLoginPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AccountLoginPost(apiV1AccountLoginPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiV1AccountLoginPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Forgot password request
         * @param {ApiV1AccountPasswordPutRequest} [apiV1AccountPasswordPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AccountPasswordPut(apiV1AccountPasswordPutRequest?: ApiV1AccountPasswordPutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Message>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AccountPasswordPut(apiV1AccountPasswordPutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiV1AccountPasswordPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary User registration
         * @param {RegisterRequest} registerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AccountRegisterPost(registerRequest: RegisterRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1AccountRegisterPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AccountRegisterPost(registerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiV1AccountRegisterPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Resend activation email
         * @param {ResendActivationRequest} resendActivationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AccountResendActivationPost(resendActivationRequest: ResendActivationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Message>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AccountResendActivationPost(resendActivationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiV1AccountResendActivationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Web user login (sets refresh cookie)
         * @param {ApiV1AccountLoginPostRequest} [apiV1AccountLoginPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AccountWebLoginPost(apiV1AccountLoginPostRequest?: ApiV1AccountLoginPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1AccountLoginPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AccountWebLoginPost(apiV1AccountLoginPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiV1AccountWebLoginPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Logout and clear refresh cookie
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AccountWebLogoutPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1AccountWebLogoutPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AccountWebLogoutPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiV1AccountWebLogoutPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Rotate web refresh token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AccountWebRefreshPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1AccountWebRefreshPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AccountWebRefreshPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiV1AccountWebRefreshPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthApi - factory interface
 */
export const AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthApiFp(configuration)
    return {
        /**
         * 
         * @summary User login
         * @param {ApiV1AccountLoginPostRequest} [apiV1AccountLoginPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccountLoginPost(apiV1AccountLoginPostRequest?: ApiV1AccountLoginPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1AccountLoginPost200Response> {
            return localVarFp.apiV1AccountLoginPost(apiV1AccountLoginPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Forgot password request
         * @param {ApiV1AccountPasswordPutRequest} [apiV1AccountPasswordPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccountPasswordPut(apiV1AccountPasswordPutRequest?: ApiV1AccountPasswordPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<Message> {
            return localVarFp.apiV1AccountPasswordPut(apiV1AccountPasswordPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary User registration
         * @param {RegisterRequest} registerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccountRegisterPost(registerRequest: RegisterRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1AccountRegisterPost200Response> {
            return localVarFp.apiV1AccountRegisterPost(registerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resend activation email
         * @param {ResendActivationRequest} resendActivationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccountResendActivationPost(resendActivationRequest: ResendActivationRequest, options?: RawAxiosRequestConfig): AxiosPromise<Message> {
            return localVarFp.apiV1AccountResendActivationPost(resendActivationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Web user login (sets refresh cookie)
         * @param {ApiV1AccountLoginPostRequest} [apiV1AccountLoginPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccountWebLoginPost(apiV1AccountLoginPostRequest?: ApiV1AccountLoginPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1AccountLoginPost200Response> {
            return localVarFp.apiV1AccountWebLoginPost(apiV1AccountLoginPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Logout and clear refresh cookie
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccountWebLogoutPost(options?: RawAxiosRequestConfig): AxiosPromise<ApiV1AccountWebLogoutPost200Response> {
            return localVarFp.apiV1AccountWebLogoutPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Rotate web refresh token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccountWebRefreshPost(options?: RawAxiosRequestConfig): AxiosPromise<ApiV1AccountWebRefreshPost200Response> {
            return localVarFp.apiV1AccountWebRefreshPost(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthApi - object-oriented interface
 */
export class AuthApi extends BaseAPI {
    /**
     * 
     * @summary User login
     * @param {ApiV1AccountLoginPostRequest} [apiV1AccountLoginPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1AccountLoginPost(apiV1AccountLoginPostRequest?: ApiV1AccountLoginPostRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiV1AccountLoginPost(apiV1AccountLoginPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Forgot password request
     * @param {ApiV1AccountPasswordPutRequest} [apiV1AccountPasswordPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1AccountPasswordPut(apiV1AccountPasswordPutRequest?: ApiV1AccountPasswordPutRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiV1AccountPasswordPut(apiV1AccountPasswordPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary User registration
     * @param {RegisterRequest} registerRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1AccountRegisterPost(registerRequest: RegisterRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiV1AccountRegisterPost(registerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resend activation email
     * @param {ResendActivationRequest} resendActivationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1AccountResendActivationPost(resendActivationRequest: ResendActivationRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiV1AccountResendActivationPost(resendActivationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Web user login (sets refresh cookie)
     * @param {ApiV1AccountLoginPostRequest} [apiV1AccountLoginPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1AccountWebLoginPost(apiV1AccountLoginPostRequest?: ApiV1AccountLoginPostRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiV1AccountWebLoginPost(apiV1AccountLoginPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Logout and clear refresh cookie
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1AccountWebLogoutPost(options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiV1AccountWebLogoutPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Rotate web refresh token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1AccountWebRefreshPost(options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiV1AccountWebRefreshPost(options).then((request) => request(this.axios, this.basePath));
    }
}

